import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { getNextZone } from '../../Utils/HomeUtil';
import { gaEmptyPositionPopupInside, gaDesignerSubstep, gaDesignerStepComplete } from '../../Utils/googleAnalytics';
import { isMobile } from 'react-device-detect';

export const EmptyZoneModal = (props) => {

	let EmptyZoneModalcurrentStep=2;
	const procced = () => {
		let offset = document.getElementsByClassName('designbody') && document.getElementsByClassName('designbody')[0] &&document.getElementsByClassName('designbody')[0].offsetTop;
		let top = 0;
		gaEmptyPositionPopupInside(
			props.selectedZone.zoneSort,
			props.selectedStage,
			"CONTINUE",
			props.selectedTemplate,
			props.selectedZone.zoneName
		);
		gaDesignerSubstep(
			EmptyZoneModalcurrentStep,
			props.selectedStage,
			props.setSelectedStage,
			props.selectedTemplate,
			props.selectedZone.zoneName,
			props.selectedZone.zoneSort-1,
			props.estimatedPrice,
			props.stoleMeta
		);
		let nextZone = getNextZone(props.selectedTemplate, props.selectedStage);
		if (nextZone === 'review-order') {
			gaDesignerStepComplete(
				EmptyZoneModalcurrentStep,
				props.selectedStage,
				props.selectedTemplate,
				null,
				null,
				props.estimatedPrice,
				props.stoleMeta			
			);
			props.setSelectedStage(nextZone);
			top = offset + 1000;
		}
		else {
			props.setSelectedStage('your-stole-' + nextZone?.zoneCode);
			top = offset + 900;
		}

		props.setShowModal(false);
	};
	const backBtnEmptyZone = () =>{
		let nextZone = getNextZone(props.selectedTemplate, props.selectedStage);
		gaEmptyPositionPopupInside(
			props.selectedZone.zoneSort,
			props.selectedStage,
			"RETURN",
			props.selectedTemplate,
			props.selectedZone.zoneName
		);

		/*gaDesignerSubstep(
			EmptyZoneModalcurrentStep,
			props.selectedStage,
			props.setSelectedStage,
			props.selectedTemplate,
			props.selectedZone.zoneName,
		    props.selectedZone.zoneSort
			);*/

		props.setShowModal(false);
	};
	return (
		<Modal
			show={props.showModal}
			onHide={() => props.setShowModal(false)}
			backdrop='static'
			centered
			dialogClassName='modal-lg' className="emptyzone-modal">
			<Modal.Header closeButton>
				<h4>
					{props.missingDecorAlert &&
						props.missingDecorAlert.title.replace(
							'<<zoneName>>',
									props.selectedZone.zoneName && props.selectedZone.zoneName.toUpperCase()
						)}
				</h4>
			</Modal.Header>
			<Modal.Body>
				<div className='row p-0 m-0 desktopview'>
					<div className='col-8 p-0'>
						<div className='row p-0 ml-0'><p>
							{props.missingDecorAlert &&
								props.missingDecorAlert.info.replace(
									/<<zoneName>>/g,
									props.selectedZone.zoneName
								)}
								</p>
						</div>
						<div className='row p-0 ml-0'><p>
							{props.missingDecorAlert && props.missingDecorAlert.optionsInfo}</p>
						</div>
						<div className='row p-10 ml-0 mt-4'>
							<Button
								variant='white'
								onClick={() =>backBtnEmptyZone()}
								className='mr-2 modal-btn'><i className="fas fa-arrow-left"></i>
								{props.missingDecorAlert && props.missingDecorAlert.backBtn}
							</Button>
							<Button variant='white modal-btn' onClick={() => procced()}>
								{props.missingDecorAlert && props.missingDecorAlert.yesBtn}  &nbsp;<i className="fas fa-arrow-right"></i>
							</Button>
						</div>
					</div>
					<div className={`col-4 p-0 d-flex align-items-center`}>
						<img
							src={process.env.REACT_APP_JOSTENS_CDN_HOST + props.images[props.selectedZone.zoneCode]}
							className='empty-zone-image'
							alt='emptyZone'
						/>
					</div>
				</div>
				<div className="mobileview">
					<div style={{textAlign:'center'}}>
					<img
							src={process.env.REACT_APP_JOSTENS_CDN_HOST + props.images[props.selectedZone.zoneCode]}
							className='empty-zone-image'
							alt='emptyZone'
						/></div>
						<p>
							{props.missingDecorAlert &&
								props.missingDecorAlert.info.replace(
									/<<zoneName>>/g,
									props.selectedZone.zoneName
								)}
								</p>
						<p>{props.missingDecorAlert && props.missingDecorAlert.optionsInfo}</p>
						<div className='row'>
							<Button
								variant='white'
								onClick={() =>backBtnEmptyZone()}
								className='mr-2 modal-btn'><i className="fas fa-arrow-left"></i>
								{props.missingDecorAlert && props.missingDecorAlert.backBtn}
							</Button>
							<Button variant='white modal-btn' onClick={() => procced()}>
								{props.missingDecorAlert && props.missingDecorAlert.yesBtn}  &nbsp;<i className="fas fa-arrow-right"></i>
							</Button>
						</div>
				</div>
			</Modal.Body>
			<Modal.Footer></Modal.Footer>
		</Modal>
	);
};
